import HelpIcon from '@mui/icons-material/Help';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Tooltip, useTheme, Box, Typography, IconButton } from '@mui/material';
import React, { FC } from 'react';

import { TAdornmentTooltip } from './AdornmentTooltip.types';

const AdornmentTooltip: FC<TAdornmentTooltip> = ({ title, type = 'help', arrow = true, placement = 'bottom' }) => {
  const theme = useTheme();

  let icon = (
    <IconButton>
      <HelpIcon fontSize='small' />
    </IconButton>
  );

  if (type === 'warning') {
    icon = (
      <IconButton>
        <WarningAmberIcon
          fontSize='small'
          sx={{
            color: theme.palette.warning.main,
          }}
        />
      </IconButton>
    );
  }

  if (type === 'warning_glow') {
    icon = (
      <Box
        sx={{
          position: 'relative',
          width: 32,
          height: 32,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 0.5,
        }}
      >
        {/* Ripple + soft glow effect */}
        <Box
          sx={{
            position: 'absolute',
            width: 32,
            height: 32,
            borderRadius: '50%',
            backgroundColor: theme.palette.warning.main,
            opacity: 0.15,
            animation: 'rippleWave 2.5s ease-out infinite',
            zIndex: 0,
            boxShadow: `0 0 8px 4px ${theme.palette.warning.main}`,
            filter: 'blur(2px)',
          }}
        />
        {/* Icon */}
        <IconButton color='warning'>
          <WarningAmberIcon
            fontSize='small'
            sx={{
              color: theme.palette.warning.main,
              zIndex: 1,
            }}
          />
        </IconButton>
        <style>{`
          @keyframes rippleWave {
            0% {
              transform: scale(1);
              opacity: 0.3;
            }
            70% {
              transform: scale(2.5);
              opacity: 0;
            }
            100% {
              transform: scale(2.5);
              opacity: 0;
            }
          }
        `}</style>
      </Box>
    );
  }

  return (
    <Tooltip
      title={
        <Typography maxWidth={'17rem'} sx={{ fontSize: '14px' }}>
          {title}
        </Typography>
      }
      placement={placement}
      arrow={arrow}
    >
      {icon}
    </Tooltip>
  );
};

export default AdornmentTooltip;
